import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const DropdownContext = createContext();

export const DropdownProvider = ({ children }) => {
  const [dropdownStates, setDropdownStates] = useState({});
  const [activeDropdownId, setActiveDropdownId] = useState(null);

  const setSelectedOption = useCallback((id, value) => {
    setDropdownStates((prev) => ({ ...prev, [id]: value }));
  }, []);

  const getSelectedOption = useCallback((id) => dropdownStates[id] || null, [dropdownStates]);
  const openDropdown = useCallback((id) => setActiveDropdownId(id), []);
  const closeDropdown = useCallback((id) => {
    setActiveDropdownId((current) => (current === id ? null : current));
  }, []);
  const isDropdownOpen = useCallback((id) => activeDropdownId === id, [activeDropdownId]);
  const value = useMemo(() => ({
    getSelectedOption,
    setSelectedOption,
    openDropdown,
    closeDropdown,
    isDropdownOpen,
  }), [
    closeDropdown,
    getSelectedOption,
    isDropdownOpen,
    openDropdown,
    setSelectedOption,
  ]);

  return (
    <DropdownContext.Provider value={value}>
      {children}
    </DropdownContext.Provider>
  );
};

export const useDropdown = () => useContext(DropdownContext);
